<template>
  <div>
    <h3 class="mb-4">{{$t("message.member")}}</h3>
    <div class="table-responsive">
        <table class="table table-bordered">
            <thead class="table-dark">
            <tr>
                <th class="text-center" style="width:40px;">#</th>
                <th>{{$t("message.name")}}</th>
                <th class="text-center">{{$t("message.gender")}}</th>
                <th class="text-center">{{$t("message.email")}}</th>
                <th class="text-center">{{$t("message.phone")}}</th>
                <th class="text-center">{{$t("message.action")}}</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in listMembers" :key="index">
                    <td class="text-center" style="vertical-align: middle;width: 30px;">{{index+1}}</td>
                    <td style="vertical-align: middle;  ">
                        {{item.lastname + ' '  + item.firstname}}
                    </td>
                    <td class="text-center" style="vertical-align: middle;">
                        {{item.gender==1?$t("message.male"):$t("message.female") }}
                    </td>
                    <td class="text-center">{{item.email}}</td>
                    <td class="text-center" style="vertical-align: middle;">{{item.phone}}</td>
                    <td class="text-center">
                        <!-- <button class="btn btn-danger"><i class="fas fa-trash"></i></button> -->
                        <router-link class="btn btn-primary" :to="{name:'showMember', params:{memberId:item.id}}">
                            <i class="fas fa-edit"></i>
                        </router-link>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
  </div>
</template>
<script>
//import axios from "@/axios";
import { mapGetters ,mapActions } from "vuex";
export default {
    setup() {
        return {};
    },
    data() {
        return {};
    },
    methods: {
        showLoader() {
            return this.$loading.show({
                container: this.$refs.formContainer,
                color: "#01B201",
                canCancel: true,
                onCancel: this.onCancelLoader
                });
        },
        ...mapActions([
            'act_loadMemeber',
        ]),
        async loadMembers(){
            let loader = this.showLoader();
            this.act_loadMemeber();
            // const respone = await axios.get("get-members", {
            //     headers: {
            //     Authorization: "Bearer " + this.$store.getters.getAuthToken
            //     }
            // });
            // if (respone.status == 200) {
            //     this.listMembers = respone.data.data;
            //     //console.log("this data member:",respone.data);
            // }
            loader.hide();
        },
    },
    computed :{
        ...mapGetters({
            getParticipant:'getParticipant',
            listMembers: 'getMember'
        }),
        getBusinessType(){
            return (t) =>{
                switch (t){
                    case '1':
                    case 1:
                        return this.$t("message.stock_business");
                    case '2':
                    case 2:
                        return this.$t("message.derivative_business");
                    case '19':
                    case 19:
                        return this.$t("message.public") + ' - ' + this.$t("message.stock_business");
                    case 20:
                    case '20':
                        return this.$t("message.public") + ' - ' + this.$t("message.derivative_business");
                    default:
                        return t;
                }
            }
        }
    },
    created() {
        this.loadMembers();
    },
    mounted() {}
}
</script>

<style scoped>
    .nopadding{
        padding: 0;
        margin: 0;
    }
    .pb{
        padding-bottom: calc(100vh - 90vh);
    }
</style>